module.exports = __webpack_public_path__ + "img/BlackRobe.2c229cee.gif";